import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Label, Badge } from '@cancercentrum/rcc-bootstrap';
import * as dataUtils from '../utils/data';
export class TabTitleSubTable extends Component {
    render() {
        const { rows, title, className } = this.props;
        const activeRows = dataUtils.getActiveRows(rows);
        const validationResult = activeRows.reduce((reduction, row)=>{
            const errors = row.getErrors();
            reduction.errors += errors.filter((x)=>x.$errors.some((y)=>y.isFatal)).length;
            reduction.warnings += errors.filter((x)=>x.$errors.some((y)=>!y.isFatal)).length;
            return reduction;
        }, {
            errors: 0,
            warnings: 0
        });
        const style = validationResult.errors > 0 ? 'danger' : validationResult.warnings > 0 ? 'warning' : undefined;
        let titleNode = /*#__PURE__*/ _jsxs("span", {
            className: className,
            children: [
                title,
                " ",
                !!activeRows.count() && /*#__PURE__*/ _jsx(Badge, {
                    bsStyle: "primary",
                    children: activeRows.count()
                })
            ]
        });
        if (validationResult.errors > 0 || validationResult.warnings > 0) {
            titleNode = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-error-wrapper",
                        children: /*#__PURE__*/ _jsx(Label, {
                            bsStyle: style,
                            className: "",
                            children: validationResult.errors + validationResult.warnings
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: titleNode
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            children: titleNode
        });
    }
}
